import { ApiResult, urlMaker, caller } from '@shared/utils';
import { DeclarationMappers } from '../mappers';
import { DeclarationSticker } from '../types/sticker';
import { translate } from '@infra/i18n/i18n';

export class DeclarationsStickerService {
  public static async getOneById(id: string | number): Promise<ApiResult<200, DeclarationSticker> | ApiResult<400 | 500, string>> {
    const url = urlMaker('/api/warehouse/declaration/info_print', { declaration_id: id });

    try {
      const response = await caller(url);

      if (response.ok) {
        const { data } = await response.json();
        const mappedData = DeclarationMappers.Sticker.oneFromApi(data);

        return new ApiResult(200, mappedData, null);
      } else {
        return new ApiResult(400, translate('common.errors.operationFailed'), null);
      }
    } catch (e) {
      return new ApiResult(500, translate('common.errors.networkFailed'), null);
    }
  }
}
